import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import { DocsSidebarNav, DocsSidebarSelect } from '../Docs.styles';
import type { DocsManifest } from '../docsContent';

export interface DocsSidebarProps {
  manifest: DocsManifest;
  currentSlug?: string;
  /** Accessible name for the nav landmark and the mobile <select>. */
  label: string;
}

export const docsHref = (slug: string) => `/ar-reference/${slug}`;

/**
 * Section list on desktop, a single <select> under 770px — the same breakpoint the rest of the
 * editor treats as mobile. Both are always rendered; CSS decides which one is visible, so the
 * links stay in the DOM for search engines and screen readers either way.
 */
const DocsSidebar = ({ manifest, currentSlug, label }: DocsSidebarProps) => {
  const history = useHistory();

  return (
    <DocsSidebarNav aria-label={label}>
      <DocsSidebarSelect
        aria-label={label}
        value={currentSlug || ''}
        onChange={(e) => history.push(docsHref(e.target.value))}
      >
        {manifest.sections.map((section) => (
          <optgroup key={section.title} label={section.title}>
            {section.pages.map((page) => (
              <option key={page.slug} value={page.slug}>
                {page.title}
              </option>
            ))}
          </optgroup>
        ))}
      </DocsSidebarSelect>

      {manifest.sections.map((section) => (
        <div key={section.title}>
          <h2>{section.title}</h2>
          <ul>
            {section.pages.map((page) => (
              <li key={page.slug}>
                <Link
                  to={docsHref(page.slug)}
                  aria-current={page.slug === currentSlug ? 'page' : undefined}
                >
                  {page.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </DocsSidebarNav>
  );
};

export default DocsSidebar;
